module.exports = __webpack_public_path__ + "img/frame (7).1b432f7d.jpg";